__webpack_require__.p = "https://lf-lemon8-web.tiktokcdn-eu.com/obj/lemon8-web-no/lemon8_web/master/default/";